import {LoginLayout,RegisterLayout, DefaultLayout} from './layouts';
import Login from './pages/Login';
import Activate from './pages/Activate';
import Password from './pages/Password';
import Builder from './pages/Builder';
import PackageSelector from './pages/PackageSelector';
import ConfirmPay from './pages/ConfirmPay';
import UserScormList from './pages/UserScormList';
import MyOrders from './pages/MyOrders';

const Routes = [  
  {
    'path'      : '/buy/:pkg',
    'secure'    : false, 
    'exact'     : true,
    layout      : DefaultLayout, 
    component   : PackageSelector
  },
  {
    'path'      : '/register', 
    'secure'    : false,     
    'exact'     : true,
    'layout'    : RegisterLayout, 
    'component' : Login
  },
  {
    'path'      : '/login', 
    'secure'    : false,    
    'exact'     : true,
    'layout'    : LoginLayout, 
    'component' : Login
  },
  {
    'path'      : '/login/:src/:username', 
    'secure'    : false,    
    'exact'     : true,
    'layout'    : LoginLayout, 
    'component' : Login
  },
  {
    'path'      : '/forgot-password', 
    'secure'    : false,    
    'exact'     : true,
    'layout'    : LoginLayout, 
    'component' : Login
  },
  {
    'path'      : '/activate/:code/:buy',
    'secure'    : false,
    'exact'     : true,
    'layout'    : LoginLayout,
    'component' : Activate
  },
  {
    'path'      : '/activate/:code', 
    'secure'    : false,    
    'exact'     : false,
    'layout'    : LoginLayout, 
    'component' : Activate
  },
  
  {
    'path'      : '/password', 
    'secure'    : true,    
    'exact'     : true,
    'layout'    : DefaultLayout, 
    'component' : Password
  },
  {
    'path'      : '/builder/:recid/:isweb',     
    'secure'    : true, 
    layout      : DefaultLayout, 
    component   : Builder
  },
  {
    'path'      : '/builder',     
    'secure'    : true, 
    layout      : DefaultLayout, 
    component   : Builder
  },
  {
    'path'      : '/scorms',
    'secure'    : true, 
    layout      : DefaultLayout, 
    component   : UserScormList
  },
  {
    'path'      : '/pay',
    'secure'    : true,
    'exact'     : true, 
    layout      : DefaultLayout, 
    component   : ConfirmPay
  },
  {
    'path'      : '/myorders',
    'secure'    : true,
    'exact'     : true, 
    layout      : DefaultLayout, 
    component   : MyOrders
  },  
  {
    'path'      : '/',
    'secure'    : true,
    'exact'     : true, 
    layout      : DefaultLayout, 
    component   : Builder
  }
];

export default Routes;